var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "downloadpage-div" }, [
    _c("img", {
      staticClass: "page-headerbg",
      attrs: { src: _vm.bgImg, alt: "" },
    }),
    _c("div", { staticClass: "page-content" }, [
      !_vm.dsf.config.setting_appdownload_ios_show ||
      _vm.dsf.config.setting_appdownload_ios_show == 1
        ? _c(
            "div",
            {
              staticClass: "downloadbutton-div",
              style: _vm.iOSStyle,
              on: { click: _vm.clickIOSButton },
            },
            [
              _c("img", {
                staticClass: "typelogo",
                attrs: { src: _vm.iOSImg, alt: "" },
              }),
              _c("div", { staticClass: "button" }, [_vm._v("iOS版下载")]),
            ]
          )
        : _vm._e(),
      !_vm.dsf.config.setting_appdownload_android_show ||
      _vm.dsf.config.setting_appdownload_android_show == 1
        ? _c(
            "div",
            {
              staticClass: "downloadbutton-div",
              style: _vm.androidStyle,
              on: { click: _vm.clickAndroidButton },
            },
            [
              _c("img", {
                staticClass: "typelogo",
                attrs: { src: _vm.androidImg, alt: "" },
              }),
              _c("div", { staticClass: "button" }, [_vm._v("Android版下载")]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }